import { lazy } from "react"
import Loadable from "./Loadable"
// ----------------------------------------------------------------------
const Login = Loadable( lazy( () => import( "../views/Login" ) ) )
const Empresas = Loadable( lazy( () => import( "../views/Empresas" ) ) )
const Home = Loadable( lazy( () => import( "../views/Home" ) ) )
const Clients = Loadable( lazy( () => import( "../views/Clients" ) ) )
const Tipos = Loadable( lazy( () => import( "../views/Tipos" ) ) )
const Usuarios = Loadable( lazy( () => import( "../views/Usuarios" ) ) )
const Registros = Loadable( lazy( () => import( "../views/Registros" ) ) )
const Deudas = Loadable( lazy( () => import( "../views/Deudas" ) ) )
const MainLayout = Loadable( lazy( () => import( "../layout/MainLayout" ) ) )

const routes = [
  // {
  //   path: "/home",
  //   element: FreeLayout,
  //   roles: ["superadmin", "admin"],
  //   isPrivate: false,
  //   children: [
  //     {
  //       path: "",
  //       element: Home,
  //       roles: ["superadmin", "admin"],
  //     },
  //   ],
  // },
  {
    path: "/",
    element: MainLayout,
    roles: [ "superadmin", "admin" ],
    isPrivate: true,
    children: [
      {
        path: "",
        element: Home,
        roles: [ "superadmin", "admin" ],
      },
      {
        path: "clientes",
        element: Clients,
        roles: [ "superadmin", "admin" ],
      },
      {
        path: "tipos",
        element: Tipos,
        roles: [ "superadmin", "admin" ],
      },
      {
        path: "empresas",
        element: Empresas,
        roles: [ "superadmin", "admin" ],
      },
      {
        path: "usuarios",
        element: Usuarios,
        roles: [ "superadmin", "admin" ],
      },
      {
        path: "registros",
        element: Registros,
        roles: [ "superadmin", "admin" ],
      },
      {
        path: "deudas",
        element: Deudas,
        roles: [ "superadmin", "admin" ],
      },
    ],
  },
  {
    path: "/login",
    element: Login,
    isPrivate: false,
    roles: [ "superadmin", "admin" ],
  },
  // {
  //   path: "/forgot-password",
  //   element: ForgotPassword,
  //   isPrivate: false,
  //   roles: ["superadmin", "admin"],
  // },
  // {
  //   path: "*",
  //   element: Page404,
  //   isPrivate: false,
  //   roles: ["superadmin", "admin"],
  // },
]

export default routes
